






















































import { Component, Ref, Vue } from 'vue-property-decorator';
import { ALL_PRODUCT_GROUPS } from '@/queries/ProductGroup';
import ProductGroupEditButton from '@/components/ProductGroup/ProductGroupEditButton.vue';
import ProductGroupNewButton from '@/components/ProductGroup/ProductGroupNewButton.vue';
import ProductGroupShowButton from '@/components/ProductGroup/ProductGroupShowButton.vue';
import ProductGroupDeleteButton from '@/components/ProductGroup/ProductGroupDeleteButton.vue';
import PermissionService from '@/utils/permission-service';
import SApolloTable from '../UI/Table/SApolloTable.vue';
import { GQL_currentUnitProductGroups_currentUnit_productGroups } from '@/queries/__generated__/currentUnitProductGroups';

@Component({
  components: {
    ProductGroupEditButton,
    ProductGroupNewButton,
    ProductGroupShowButton,
    ProductGroupDeleteButton,
  },
})
export default class ProductGroupList extends Vue {
  @Ref() private table?: SApolloTable<GQL_currentUnitProductGroups_currentUnit_productGroups>;

  private ALL_PRODUCT_GROUPS = ALL_PRODUCT_GROUPS;
  private PermissionService = PermissionService;

  private resetTableResult() {
    this.table?.refetch();
  }
}
